import type { BillingRepository } from "@/data/repositories/billingRepository";
import { PLAN_CATALOG, type BillingInvoice, type BillingProfile } from "@/types/billing";
import type { SubscriptionPlan } from "@/types/organization";

export class DummyBillingRepository implements BillingRepository {
  private profiles = new Map<string, BillingProfile>();
  async getProfile(organizationId: string) {
    const existing = this.profiles.get(organizationId);
    if (existing) return existing;
    const created: BillingProfile = { organizationId, plan: "studio", status: "trialing", seatsUsed: 3, seatsLimit: 5, storageUsedBytes: 18.4 * 1024 ** 3, storageLimitBytes: 50 * 1024 ** 3, currentPeriodEnd: "2026-09-15T00:00:00Z" };
    this.profiles.set(organizationId, created);
    return created;
  }
  async listInvoices(organizationId: string): Promise<BillingInvoice[]> {
    return [
      { id: "inv_02", organizationId, invoiceNumber: "ATL-2026-0082", amount: 899, currency: "MXN", status: "paid", issuedAt: "2026-08-15T10:00:00Z", paidAt: "2026-08-15T10:01:00Z" },
      { id: "inv_01", organizationId, invoiceNumber: "ATL-2026-0071", amount: 899, currency: "MXN", status: "paid", issuedAt: "2026-07-15T10:00:00Z", paidAt: "2026-07-15T10:01:00Z" },
    ];
  }
  async changePlan(organizationId: string, plan: SubscriptionPlan) {
    const current = await this.getProfile(organizationId);
    const catalog = PLAN_CATALOG[plan];
    const updated = { ...current, plan, seatsLimit: catalog.seats, storageLimitBytes: catalog.storageGb * 1024 ** 3 };
    this.profiles.set(organizationId, updated);
    return updated;
  }
}
